import { EmptyStateImages, EmptyStateImagesOld } from '../../../components/common';
import { HELP_LINKS } from '../../../constants/HelpLinks';
import { AddFilesToBoardButton } from './buttons/AddFilesToBoardButton';
import { ExploreShutterstockButton } from './buttons/ExploreShutterstockButton';
import { GetAppButton } from './buttons/GetAppButton';
import { GoToSiteFilesButton } from './buttons/GoToSiteFilesButton';
import { LearnMoreButton } from './buttons/LearnMoreButton';
import { ResetFiltersButton } from './buttons/ResetFiltersButton';
import { ResetSearchButton } from './buttons/ResetSearchButton';
import { SiteFilesNewDnDButton } from './buttons/SiteFilesNewDnDButton';
import { TryAgainButton } from './buttons/TryAgainButton';
import { LearnMoreLink } from './buttons/LearnMoreLink/LearnMoreLink';
import { EmptyStateType, TConfigMapper } from './EmptyState.types';
import { BoardSubtitle } from './subtitles/BoardSubtitle';
import { FavoritesSubtitle } from './subtitles/FavoritesSubtitle';
import { MediaFromWixSubtitle } from './subtitles/MediaFromWixSubtitle';
import { MobileSubtitle } from './subtitles/MobileSubtitle';
import { NetworkErrorSubtitle, NewNetworkErrorSubtitle } from './subtitles/NetworkErrorSubtitle';
import { NewNotAuthorizedSubtitle, NotAuthorizedSubtitle } from './subtitles/NotAuthorizedSubtitle';
import { PurchasedSubtitle } from './subtitles/PurchasedSubtitle';
import { SearchBySourceSubtitle } from './subtitles/SearchBySourceSubtitle';
import { NewSearchSubtitle, SearchSubtitle } from './subtitles/SearchSubtitle/SearchSubtitle';
import { ShutterstockSubtitle } from './subtitles/ShutterstockSubtitle';
import { SiteFilesNewDnDSubtitle } from './subtitles/SiteFilesNewDnDSubtitle/SiteFilesNewDnDSubtitle';
import { TrashSubtitle } from './subtitles/TrashSubtitle';
import { NewUnknownErrorSubtitle, UnknownErrorSubtitle } from './subtitles/UnknownErrorSubtitle/UnknownErrorSubtitle';
import { VisitorUploadsSubtitle } from './subtitles/VisitorUploadsSubtitle';
import { BoardTitle } from './titles/BoardTitle';
import { FavoritesTitle } from './titles/FavoritesTitle';
import { MediaFromWixTitle } from './titles/MediaFromWixTitle';
import { MobileTitle } from './titles/MobileTitle';
import { NetworkErrorTitle } from './titles/NetworkErrorTitle';
import { NewNotAuthorizedTitle, NotAuthorizedTitle } from './titles/NotAuthorizedTitle';
import { PurchasedTitle } from './titles/PurchasedTitle';
import { SearchBySourceTitle } from './titles/SearchBySourceTitle';
import { NewSearchTitle, SearchTitle } from './titles/SearchTitle';
import { ShutterstockTitle } from './titles/ShutterstockTitle';
import { SiteFilesNewDnDTitle } from './titles/SiteFilesNewDnDTitle';
import { TrashTitle } from './titles/TrashTitle';
import { NewUnknownErrorTitle, UnknownErrorTitle } from './titles/UnknownErrorTitle';
import { VisitorUploadsTitle } from './titles/VisitorUploadsTitle';
import { EnterpriseTitle } from './titles/EnterpriseTitle';
import { NewBoardSubtitle } from './subtitles/NewBoardSubtitle/NewBoardSubtitle';
import { NewSearchButtons } from './buttons/NewSearchButtons';

export const EmptyStatesConfigs: TConfigMapper = {
  [EmptyStateType.SiteFilesNewDnD]: {
    image: EmptyStateImagesOld.Archived,
    Title: SiteFilesNewDnDTitle,
    Subtitle: SiteFilesNewDnDSubtitle,
    Button: SiteFilesNewDnDButton,
  },
  [EmptyStateType.NetworkError]: {
    image: EmptyStateImagesOld.SomethingWentWrong,
    Title: NetworkErrorTitle,
    Subtitle: NetworkErrorSubtitle,
    Button: TryAgainButton,
  },
  [EmptyStateType.NotAuthorized]: {
    image: EmptyStateImagesOld.SomethingWentWrong,
    Title: NotAuthorizedTitle,
    Subtitle: NotAuthorizedSubtitle,
    Button: TryAgainButton,
  },
  [EmptyStateType.UnknownError]: {
    image: EmptyStateImagesOld.SomethingWentWrong,
    Title: UnknownErrorTitle,
    Subtitle: UnknownErrorSubtitle,
    Button: GoToSiteFilesButton,
  },
  [EmptyStateType.Mobile]: {
    image: EmptyStateImagesOld.Mobile,
    Title: MobileTitle,
    Subtitle: MobileSubtitle,
    Button: GetAppButton,
  },
  [EmptyStateType.Purchased]: {
    image: EmptyStateImagesOld.Purchased,
    Title: PurchasedTitle,
    Subtitle: PurchasedSubtitle,
    Button: ExploreShutterstockButton,
  },
  [EmptyStateType.Trash]: {
    image: EmptyStateImagesOld.EmptyTrashImage,
    Title: TrashTitle,
    Subtitle: TrashSubtitle,
    Button: LearnMoreButton,
    buttonProps: {
      link: HELP_LINKS.LEARN_MORE_TRASH,
    },
  },
  [EmptyStateType.Favorites]: {
    image: EmptyStateImagesOld.Favorites,
    Title: FavoritesTitle,
    Subtitle: FavoritesSubtitle,
  },
  [EmptyStateType.VisitorUploads]: {
    image: EmptyStateImagesOld.VisitorUploads,
    Title: VisitorUploadsTitle,
    Subtitle: VisitorUploadsSubtitle,
  },
  [EmptyStateType.MediaFromWix]: {
    image: EmptyStateImagesOld.Search,
    Title: MediaFromWixTitle,
    Subtitle: MediaFromWixSubtitle,
    Button: ResetFiltersButton,
  },
  [EmptyStateType.Enterprise]: {
    image: EmptyStateImagesOld.Search,
    Title: EnterpriseTitle,
  },
  [EmptyStateType.Shutterstock]: {
    image: EmptyStateImagesOld.Search,
    Title: ShutterstockTitle,
    Subtitle: ShutterstockSubtitle,
    Button: ResetFiltersButton,
  },
  [EmptyStateType.Search]: {
    image: EmptyStateImagesOld.Search,
    Title: SearchTitle,
    Subtitle: SearchSubtitle,
    Button: ResetSearchButton,
  },
  [EmptyStateType.SearchBySource]: {
    image: EmptyStateImagesOld.Search,
    Title: SearchBySourceTitle,
    Subtitle: SearchBySourceSubtitle,
    Button: ResetSearchButton,
  },
  [EmptyStateType.Board]: {
    image: EmptyStateImagesOld.Board,
    Title: BoardTitle,
    Subtitle: BoardSubtitle,
    Button: AddFilesToBoardButton,
  },
};

export const NewEmptyStatesConfigs: TConfigMapper = {
  ...EmptyStatesConfigs,
  [EmptyStateType.NetworkError]: {
    image: EmptyStateImages.NetworkUnstable,
    Title: NetworkErrorTitle,
    Subtitle: NewNetworkErrorSubtitle,
    Button: TryAgainButton,
    buttonProps: {
      message: 'empty-state.server-error-link',
    },
  },
  [EmptyStateType.NotAuthorized]: {
    image: EmptyStateImages.NotAuthorized,
    Title: NewNotAuthorizedTitle,
    Subtitle: NewNotAuthorizedSubtitle,
    Button: TryAgainButton,
    buttonProps: {
      message: 'empty-state.not-authorized-link',
    },
  },
  [EmptyStateType.UnknownError]: {
    image: EmptyStateImages.UnknownError,
    Title: NewUnknownErrorTitle,
    Subtitle: NewUnknownErrorSubtitle,
    Button: TryAgainButton,
    buttonProps: {
      message: 'empty-state.server-error-link',
    },
  },
  [EmptyStateType.Trash]: {
    image: EmptyStateImages.EmptyTrashImage,
    Title: TrashTitle,
    Subtitle: TrashSubtitle,
    Button: LearnMoreLink,
    buttonProps: {
      link: HELP_LINKS.LEARN_MORE_TRASH,
    },
  },
  [EmptyStateType.MediaFromWix]: {
    image: EmptyStateImages.Search,
    Title: NewSearchTitle,
    Subtitle: NewSearchSubtitle,
    Button: NewSearchButtons,
  },
  [EmptyStateType.Enterprise]: {
    image: EmptyStateImages.Search,
    Title: NewSearchTitle,
    Subtitle: NewSearchSubtitle,
    Button: NewSearchButtons,
  },
  [EmptyStateType.Shutterstock]: {
    image: EmptyStateImages.Search,
    Title: NewSearchTitle,
    Subtitle: NewSearchSubtitle,
    Button: NewSearchButtons,
  },
  [EmptyStateType.Search]: {
    image: EmptyStateImages.Search,
    Title: NewSearchTitle,
    Subtitle: NewSearchSubtitle,
    Button: NewSearchButtons,
  },
  [EmptyStateType.SearchBySource]: {
    image: EmptyStateImages.Search,
    Title: NewSearchTitle,
    Subtitle: NewSearchSubtitle,
    Button: NewSearchButtons,
  },
  [EmptyStateType.Board]: {
    image: EmptyStateImages.Board,
    Title: BoardTitle,
    Subtitle: NewBoardSubtitle,
    Button: AddFilesToBoardButton,
  },
};
